import { Menu } from "antd";
import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PoweroffOutlined, UserSwitchOutlined } from "@ant-design/icons";

import { signOutSuccess } from "redux/actions/Auth";

import axios from "auth/FetchInterceptor";

export default function useNavSignout({ intl }) {

    // REDUX - STATE
    const dropDownRef = useRef();
    const dispatch = useDispatch();

    const { locale } = useSelector(state => state.theme);
    const { profile } = useSelector(({ users }) => users);
    //const { viewPortWidth } = useSelector(state => state.app);

    const signOutOption = {
        key: 0,
        label: (
            <a target="#" onClick={() => setWillSignout(true)}>
                <PoweroffOutlined className="mr-1" />
                {intl.formatMessage({ id: 'auth.sign_out' })}
            </a>
        ),
    };

    const [closing, setClosing] = useState(false);
    const [willSignout, setWillSignout] = useState(false);
    const [attachedCompanies, setAttachedCompanies] = useState([signOutOption]);

    // FUNCTIONS

    const handleSignout = () => {
        setClosing(true);
        setTimeout(() => {
            setClosing(false);
            setWillSignout(false);
            dispatch(signOutSuccess());
        }, 2000);
    };

    const handleCancelSignout = () => {
        setWillSignout(false);
    };

    const changeCompany = (companyId) => {
        axios.put(`user/switch/company/${companyId}`, { companyId }).then((res) => {
            if (res.success) {
                window.location.reload();
            }
        });
    };

    // EFFECTS

    useEffect(() => {
        const itemsCopy = [...attachedCompanies];
        const signOutOption = itemsCopy.find((item) => item.key === 0);
        if (signOutOption) {
            signOutOption.label = (
                <a target="#" onClick={() => setWillSignout(true)}>
                    <PoweroffOutlined className="mr-1" />
                    {intl.formatMessage({ id: 'auth.sign_out' })}
                </a>
            );
        }

        setAttachedCompanies(itemsCopy);

    }, [locale]);

    useEffect(() => {
        if (profile.attachedCompanies && profile.attachedCompanies.length !== 0) {
            const companiesOptions = profile.attachedCompanies.map((c) => ({
                key: `company-${c.id}`,
                label: (
                    <p onClick={() => changeCompany(c.id)}>
                        <UserSwitchOutlined /> {c.name}
                    </p>
                ),
            }));
            setAttachedCompanies([...attachedCompanies, ...companiesOptions]);
        }
    }, [profile]);

    const userMenu = <Menu items={attachedCompanies}></Menu>;

    return {
        profile,
        closing,
        userMenu,
        willSignout,
        dropDownRef,
        handleSignout,
        handleCancelSignout
    };
}